import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { XCircleIcon, RadioButtonIcon } from "../../assets/svgs/SvgsImg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/AddPurchasingOrderModal.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddPurchasingOrderModal = ({ isOpen, onClose }) => {
  const history = useHistory();
  const [selectedType, setSelectedType] = useState("rent"); // Default selection is 'rent'
  const handleChange = (event) => {
    setSelectedType(event.target.value); // Update the selected type on change
  };

  const handleAddClick = () => {
    if (selectedType === "rent") {
      history.push("/add-rent-order");
    } else {
      history.push("/add-purchasing-order");
    }
    localStorage.setItem("isAddNewOrder", true);
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Stock Overview").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-dialog"
    >
      <Modal.Body className="modal-body-custom shadow-lg no-border">
        <div className="top-section">
          <span></span>
          <span
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: "bold",
              fontSize: "16px",
              color: "#00246A",
            }}
          >
            {/* Type of purchasing */}
            {t("Type of purchasing")}
          </span>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            <XCircleIcon />
          </div>
        </div>

        <div
          className="d-flex flex-column align-items-start dimensions"
          style={{
            marginTop: "33px", // Fixed margin top
            marginLeft: "77px", // Fixed margin left
          }}
        >
          <div className="d-flex align-items-center">
            <input
              type="radio"
              id="rent"
              name="type"
              value="rent"
              style={{ display: "none" }} // Hide default radio input
              checked={selectedType === "rent"} // Check if this radio is selected
              onChange={handleChange} // Handle change
            />
            <label
              htmlFor="rent"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Custom radio button */}
              {selectedType === "rent" ? (
                <RadioButtonIcon /> // Custom radio button icon
              ) : (
                <div
                  style={{
                    cursor: "pointer",
                    width: "16px",
                    height: "16px",
                    border: "2px solid #ccc",
                    borderRadius: "50%", // Make it circular like a radio button
                  }}
                ></div>
              )}
              <span style={{ marginLeft: "14px" }}>
                {/* Rent */}
                {t("Rent")}
              </span>
            </label>
          </div>

          {/* Purchasing Radio Button */}
          <div
            className="d-flex align-items-center"
            style={{ marginTop: "20px" }}
          >
            <input
              type="radio"
              id="purchasing"
              name="type"
              value="purchasing"
              style={{ display: "none" }} // Hide default radio input
              checked={selectedType === "purchasing"} // Check if this radio is selected
              onChange={handleChange} // Handle change
            />
            <label
              htmlFor="purchasing"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Custom radio button */}
              {selectedType === "purchasing" ? (
                <RadioButtonIcon /> // Custom radio button icon
              ) : (
                <div
                  style={{
                    cursor: "pointer",
                    width: "16px",
                    height: "16px",
                    border: "2px solid #ccc",
                    borderRadius: "50%", // Circular like a radio button
                  }}
                ></div>
              )}
              <span style={{ marginLeft: "14px" }}>
                {/* Purchasing */}
                {t("Purchasing")}
              </span>
            </label>
          </div>
        </div>

        {/* button */}
        <div
          className="dimensions"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "54px",
            alignItems: "center", // Center the button vertically
          }}
        >
          <button
            onClick={handleAddClick} // Call handleAddClick on button click
            style={{
              width: "132px",
              height: "42px",
              backgroundColor: "#00246A",
              color: "#ffffff",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
            }}
          >
            {/* Add */}
            {t("Add")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddPurchasingOrderModal;
